import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrency from 'components/ui/FormattedCurrency';
import Modal from 'components/ui/Modal';
import getPassengerTypeTranslationId from 'utils/getPassengerTypeTranslationId';

import {
  StyledBreakdownModal,
  StyledBreakdownModalTitle,
  StyledBreakdownSection,
  StyledBreakdownSectionTitle,
  StyledCarrierFee
} from './FeeBreakdownModal.styles';

const FeeBreakdownModal = ({ isOpen, onClose, testIdPrefix, titleMessageId, amount, currency, carrierMessageId, sections }) => (
  <Modal isOpen={isOpen} onClose={onClose} minWidth="920px">
    <StyledBreakdownModal data-testid={`${testIdPrefix}-breakdown-modal`}>
      <StyledBreakdownModalTitle data-testid={`${testIdPrefix}-breakdown-title`}>
        <FormattedMessage id={titleMessageId} />: <FormattedCurrency amount={amount} currency={currency} />
      </StyledBreakdownModalTitle>
      {sections.map((section) => (
        <StyledBreakdownSection key={section.direction} data-testid={`${testIdPrefix}-section-${section.direction}`}>
          <StyledBreakdownSectionTitle>
            <FormattedMessage id={`journeySegment.${section.direction}`} />:{' '}
            <FormattedCurrency amount={section.total} currency={currency} />
          </StyledBreakdownSectionTitle>
          {section.carriers.map((carrier) => (
            <StyledCarrierFee key={`${section.direction}-${carrier.key}`}>
              <FormattedMessage id={carrierMessageId} values={{ serviceTypeName: carrier.serviceTypeName }} />:{' '}
              {carrier.feeGroups.length > 0 ? (
                carrier.feeGroups.map((feeGroup, index) => (
                  <Fragment key={`${carrier.key}-${feeGroup.passengerType}-${feeGroup.amount}`}>
                    {index > 0 && ' + '}
                    {feeGroup.quantity} <FormattedMessage id={getPassengerTypeTranslationId(feeGroup.passengerType, feeGroup.quantity)} /> x{' '}
                    <FormattedCurrency amount={feeGroup.amount} currency={currency} />
                  </Fragment>
                ))
              ) : (
                <FormattedCurrency amount={carrier.total} currency={currency} />
              )}
            </StyledCarrierFee>
          ))}
        </StyledBreakdownSection>
      ))}
    </StyledBreakdownModal>
  </Modal>
);

const sectionShape = PropTypes.shape({
  direction: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  carriers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      serviceTypeName: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      feeGroups: PropTypes.arrayOf(
        PropTypes.shape({
          passengerType: PropTypes.string.isRequired,
          amount: PropTypes.number.isRequired,
          quantity: PropTypes.number.isRequired
        })
      ).isRequired
    })
  ).isRequired
});

FeeBreakdownModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  testIdPrefix: PropTypes.string.isRequired,
  titleMessageId: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  carrierMessageId: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(sectionShape).isRequired
};

export default FeeBreakdownModal;
